import React from 'react';
import PropTypes from 'prop-types';
import DataTable from '../reporting_utils/DataTable';

const $ = window.$;

function MarketingBreakdown({ tableData, currentMonth }) {
  const currentMonthData = tableData.filter((data) => data.start_date === currentMonth);

  const formattedData = currentMonthData.map((campaign) => {
    const six_month_avg_bookable_calls =
      tableData
        .filter((data) => data.campaign_id === campaign.campaign_id)
        .reduce((acc, data) => acc + data.bookable_calls, 0) / 6;

    const six_month_avg_appt_calls =
      tableData
        .filter((data) => data.campaign_id === campaign.campaign_id)
        .reduce((acc, data) => acc + data.appt_calls, 0) / 6;

    const six_month_avg_appt_conversion_rate = Math.round(
      tableData
        .filter((data) => data.campaign_id === campaign.campaign_id)
        .reduce((acc, data) => acc + data.appt_conversion_rate, 0) / 6
    );

    const prospect_rate = Math.round((campaign.prospect_calls / campaign.leadscore_calls) * 100);

    const sixMonthAvgProspectCalls =
      tableData
        .filter((data) => data.campaign_id === campaign.campaign_id)
        .reduce((acc, data) => acc + data.prospect_calls, 0) / 6;

    const sixMonthAvgQualifiedCalls =
      tableData
        .filter((data) => data.campaign_id === campaign.campaign_id)
        .reduce((acc, data) => acc + data.leadscore_calls, 0) / 6;

    const six_month_avg_prospect_rate = Math.round(
      (sixMonthAvgProspectCalls / sixMonthAvgQualifiedCalls) * 100
    );

    return {
      ...campaign,
      six_month_avg_bookable_calls,
      six_month_avg_appt_calls,
      six_month_avg_appt_conversion_rate,
      prospect_rate,
      six_month_avg_prospect_rate,
    };
  });

  const maxBookablePropsects = Math.max(...tableData.map((data) => data.bookable_calls));
  const maxSixMonthBookableProspects = Math.max(
    ...tableData.map((data) => data.six_month_avg_bookable_calls)
  );

  const columnDefs = [
    {
      title: 'Current Month',
      children: [
        { data: 'campaign_name', title: 'Ad Sources' },
        { data: 'total_calls', render: $.fn.dataTable.render.number(','), title: 'Total' },
        {
          data: 'leadscore_calls',
          render: $.fn.dataTable.render.number(','),
          title: 'Qualified',
        },
        { data: 'prospect_calls', render: $.fn.dataTable.render.number(','), title: 'Prospects' },
        {
          data: 'bookable_calls',
          render: $.fn.dataTable.render.number(','),
          createdCell: (td, cellData) => {
            const percentage = cellData / maxBookablePropsects;
            $(td).css('background-color', `rgba(22, 163, 74, ${percentage})`);
          },
          title: 'Bookable Prospects',
        },
        {
          data: 'prospect_rate',
          render: (data, type) => {
            if (type === 'sort') {
              return data;
            } else if (data) {
              return `${data}%`;
            } else {
              return '--';
            }
          },
          type: 'num',
          title: 'Prospect %',
        },
        { data: 'appt_calls', render: $.fn.dataTable.render.number(','), title: 'Appts' },
        {
          data: 'appt_conversion_rate',
          render: (data, type) => {
            if (type === 'sort') {
              return data;
            } else if (data) {
              return `${data}%`;
            } else {
              return '--';
            }
          },
          type: 'num',
          title: 'Conv %',
        },
      ],
    },
    {
      title: '6 Month Avg',
      children: [
        {
          data: 'six_month_avg_bookable_calls',
          render: $.fn.dataTable.render.number(','),
          createdCell: (td, cellData) => {
            const percentage = cellData / maxSixMonthBookableProspects;
            $(td).css('background-color', `rgba(22, 163, 74, ${percentage})`);
          },
          title: 'Bookable Prospects',
        },
        {
          data: 'six_month_avg_prospect_rate',
          render: (data, type) => {
            if (type === 'sort') {
              return data;
            } else if (data) {
              return `${data}%`;
            } else {
              return '--';
            }
          },
          type: 'num',
          title: 'Prospect %',
        },
        {
          data: 'six_month_avg_appt_calls',
          render: $.fn.dataTable.render.number(','),
          title: 'Appts',
        },
        {
          data: 'six_month_avg_appt_conversion_rate',
          render: (data, type) => {
            if (type === 'sort') {
              return data;
            } else if (data) {
              return `${data}%`;
            } else {
              return '--';
            }
          },
          type: 'num',
          title: 'Conv %',
        },
      ],
    },
  ];

  return (
    <div>
      <h3 className='text-center'>Breakdown of Top 25 Ad Sources</h3>
      <DataTable
        data={formattedData}
        columnDefs={columnDefs}
        title='Breakdown of Top 25 Ad Sources'
        order={[4, 'desc']}
      />
    </div>
  );
}

MarketingBreakdown.propTypes = {
  tableData: PropTypes.array.isRequired,
  currentMonth: PropTypes.string.isRequired,
};

export default MarketingBreakdown;
